import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeOptions, Theme } from '@material-ui/core/styles/createMuiTheme';
import { default as breakpoints } from './breakpoints';
import { palette, paletteDark } from './palette';
import { shape } from './shape';
import { default as typography } from './typography';
// FIXME in PLAT-1384: circular dependency with other files
// eslint-disable-next-line import/no-cycle
import { getOverrides } from './overrides';

export function createTheme(options?: ThemeOptions): Theme {
  const type = options && options.palette && options.palette.type;
  const direction = options && options.direction;

  const partialTheme = createMuiTheme({
    breakpoints,
    typography,
    shape,
    direction: direction === 'rtl' ? 'rtl' : 'ltr',
    palette: type === 'dark' ? paletteDark : palette,
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
    },
  });

  return createMuiTheme({
    ...partialTheme,
    overrides: getOverrides(partialTheme),
  });
}

export const bbTheme: Theme = createTheme();
export const bbThemeDark: Theme = createTheme({ palette: { type: 'dark' } });

export default bbTheme;
